import { serviceURL } from "./global";
import axios from 'axios';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { extApiKey, getCountry } from "../environment/Environment";
export { invoke, invokePost, invokeGet }

function getosInfo() {
    const platform = navigator.platform;
    let os;
    if (platform.indexOf('Win') > -1) os = "Windows";
    else if (platform.indexOf('Mac') > -1) os = "MacOs";
    else if (platform.indexOf('Linux') > -1) os = "Linux";
    else if (platform.indexOf('iphone') > -1 || platform.indexOf('ipad') > -1) os = "iOS";
    else if (platform.indexOf('Android') > -1) os = "Android";
    else os = "Unknown OS"
    return os;
}
function getdeviceType() {
    const userAgent = navigator.userAgent;
    if (/Mobi|Android/i.test(userAgent)) {
        return "Mobile";
    } else if (/ipad|Tablet/i.test(userAgent)) {
        return "Tablet";
    } else {
        return "Desktop";
    }
}
function getbrowserInfo() {
    const userAgent = navigator.userAgent;
    let browserName, browserVersion;
    if (userAgent.indexOf('Firefox') > -1) {
        browserName = "Mozilla Firefox";
        browserVersion = userAgent.match(/Firefox\/([0-9]+(\.[0-9]+)?)/)[1];
    } else if (userAgent.indexOf('Chrome') > -1) {
        browserName = "Google Chrome";
        browserVersion = userAgent.match(/Chrome\/([0-9]+(\.[0-9]+)?)/)[1];
    } else if (userAgent.indexOf('Safari') > -1) {
        browserName = "Apple Safari";
        browserVersion = userAgent.match(/Version\/([0-9]+(\.[0-9]+)?)/)[1];
    } else if (userAgent.indexOf('Edge') > -1) {
        browserName = "Microsoft Edge";
        browserVersion = userAgent.match(/Edge\/([0-9]+(\.[0-9]+)?)/)[1];
    } else {
        browserName = "Unknown Browser"
        browserVersion = "Unknown Version"
    }
    return { browserName, browserVersion }
}

function generateUUID() {
    return 'xxxx-xxxx-4xxx-yxxx-xxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        // eslint-disable-next-line
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(24);
    });
}

const getCountryApi = async () => {
    let trySuccess = false;
    let catchSuccess = false;
    try {
        const response = await axios.get(`${getCountry}`, {
            headers: { 'x-api-key': `${extApiKey}` }
        })
        trySuccess = true;
        if (response.status === 200) {
            const resData = response.data.clientRequest;
            const ip = resData['source-ip'];
            const country = resData['X-Country']
            return { ip, country }
        }
    } catch (error) {
        const response = await axios.get(`${getCountry}`, {
            headers: { 'x-api-key': `${extApiKey}` }
        })
        catchSuccess = true;
        if (response.status === 200) {
            const resData = response.data.clientRequest;
            const ip = resData['source-ip'];
            const country = resData['X-Country']
            return { ip, country }
        }
    } finally {
        if (!trySuccess && !catchSuccess) {
            const response = await axios.get(`${getCountry}`, {
                headers: { 'x-api-key': `${extApiKey}` }
            })
            if (response.status === 200) {
                const resData = response.data.clientRequest;
                const ip = resData['source-ip'];
                const country = resData['X-Country']
                return { ip, country }
            }
        }
    }
}

async function defaultHeader() {
    let browserInfo = getbrowserInfo();
    let osInfo = getosInfo();
    let deviceType = getdeviceType();

    const getDeviceID = async () => {
        const fp = await FingerprintJS.load();
        const result = await fp.get()
        return result.visitorId;
    }

    let deviceId = await getDeviceID();

    let country;
    try {
        country = await getCountryApi();

    } catch (error) {
        console.error(error, "country fails")
    }

    return {
        'Content-type': "application/json",
        'Browser-name': browserInfo.browserName,
        'Browser-version': browserInfo.browserVersion,
        "Operating-system": osInfo,
        'Device-type': deviceType,
        "senderId": "WEB",
        "correlationId": generateUUID(),
        ...(country?.country ? { "X-Country": country.country } : {}),
        "Device-Id": deviceId,
        ...(country?.ip ? { "Source-Ip": country.ip } : {})
    }
}

async function customHeader() {
    return {
        'Content-type': "application/json",
        "senderId": "WEB",
        "correlationId": generateUUID(),
    }
}

function invoke(url, data, method) {
    return method(url, data);
}
async function invokePost(url, data) {
    try {
        let Url = `${serviceURL.BaseUrl}${url}`;
        let headerConfig = { headers: await defaultHeader() };
        let response = await axios.post(Url, data, headerConfig)
        if (response.status === 200) {
            return response;
        } else {
            console.log("status not 200");
        }
    } catch (error) {
        console.log(error);
        return error;
    }
}
// this get invoke methods helps only in the getting QR events, 
// because the data is directly used in url for fetching
async function invokeGet(url, data) {
    try {
        let Url = `${serviceURL.BaseUrl}${url}`;
        let headerConfig = { headers: await customHeader() };
        let response = await axios.get(`${Url}/${data}`, headerConfig)
        if (response.status === 200) {
            return response;
        } else {
            console.log("status not 200");
        }
    } catch (error) {
        console.log(error);
        return error;
    }
}